module.exports = __webpack_public_path__ + "static/media/linkedinbutton.a9acd070.png";